var map = {
	"./en-US/hiperme-en-US.json": [
		"0f73",
		"lang-en-US-hiperme-en-US-json"
	],
	"./es-ES/hiperme-es-ES.json": [
		"ba9e",
		"lang-es-ES-hiperme-es-ES-json"
	],
	"./pt-BR/hiperme-pt-BR.json": [
		"c004",
		"lang-pt-BR-hiperme-pt-BR-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8f68";
module.exports = webpackAsyncContext;